// @ts-nocheck
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { ENERGY_ALERT_TYPES } from '../energyOverviewUtils';
import { EnergyEmptyCardState, ENERGY_TEXT_PRIMARY, ENERGY_TEXT_SECONDARY } from './EnergyOverviewCard.jsx';

const HOUR_MS = 60 * 60 * 1000;
const DAY_MS = 24 * HOUR_MS;

const ALERT_ENTITIES = {
  [ENERGY_ALERT_TYPES.ON_TOO_LONG]: 'energyOverviewAlertOnTooLong',
  [ENERGY_ALERT_TYPES.NEVER_SWITCHED_ON]: 'energyOverviewAlertNeverSwitchedOn',
  [ENERGY_ALERT_TYPES.SENSOR_NOT_REPORTING]: 'energyOverviewAlertSensorNotReporting',
  [ENERGY_ALERT_TYPES.INHIBITED_TOO_LONG]: 'energyOverviewAlertInhibitedTooLong',
};

function renderAlertDescription(alert) {
  const entity = ALERT_ENTITIES[alert.type];
  if (!entity) return alert.details || alert.type;
  const durationMs = alert.durationMs || 0;
  return (
    <Entity
      entity={entity}
      data={{
        hours: Math.floor(durationMs / HOUR_MS),
        days: Math.floor(durationMs / DAY_MS),
      }}
    />
  );
}

const EnergyAlertsList = ({ alerts, onAlertClick, maxHeight = 220 }) => {
  if (_.isEmpty(alerts)) {
    return <EnergyEmptyCardState height={maxHeight} entity="energyOverviewNoAlerts" />;
  }
  return (
    <div style={{ maxHeight, overflowY: 'auto' }}>
      {_.map(alerts, alert => (
        <div
          key={`${alert.pcuId}_${alert.type}`}
          role="button"
          tabIndex={0}
          onClick={() => onAlertClick && onAlertClick(alert)}
          style={{ display: 'flex', alignItems: 'flex-start', padding: '6px 0', cursor: onAlertClick ? 'pointer' : 'default' }}
        >
          <ErrorOutlineIcon style={{ fontSize: 18, color: '#ff9800', marginRight: 10, marginTop: 1 }} />
          <div>
            <h5 style={{ margin: 0, fontWeight: 'bold', fontSize: 13, color: ENERGY_TEXT_PRIMARY }}>{alert.pcuName || alert.pcuId}</h5>
            <h6 style={{ margin: 0, marginTop: 2, fontSize: 12, color: ENERGY_TEXT_SECONDARY }}>{renderAlertDescription(alert)}</h6>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EnergyAlertsList;
